<template>
  <div class="circle-progress" :class="progressClass">
    <div class="circle-progress__progress">
      <slot name="progress" v-bind:progress="returnedValues"></slot>
    </div>
    <svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        r="32"
        cx="36"
        cy="36"
        stroke="#F8F8F8"
        :stroke-dasharray="c"
        stroke-width="8"
      />
      <circle
        v-if="!progressClass"
        class="circle-progress__circle"
        r="32"
        cx="36"
        cy="36"
        stroke="#A0CE67"
        stroke-width="8"
        :stroke-dasharray="c"
        :style="`stroke-dashoffset: ${progress}`"
      />
      <circle
        v-else
        class="circle-progress__circle"
        r="32"
        cx="36"
        cy="36"
        stroke="#A0CE67"
        stroke-width="8"
        :stroke-dasharray="c"
        :style="`stroke-dashoffset: -${progress}`"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    value: Number,
    total: Number,
    progressClass: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    r: 32,
  }),
  computed: {
    returnedValues() {
      return {
        value: this.value,
        total: this.total,
      }
    },
    progress() {
      return this.c - (this.value / this.total) * this.c
    },
    c() {
      return Math.PI * (this.r * 2)
    },
  },
}
</script>

<style lang="scss" scoped>
svg circle {
  stroke-dashoffset: 0;
  border-radius: 30px;
  transition: stroke-dashoffset 1s linear;
  stroke-linecap: round;
}

.circle-progress {
  position: relative;
  width: 72px;
  height: 72px;
  flex-shrink: 0;

  &__progress {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__circle {
    transform: rotate(-90deg);
    transform-origin: 50%;
  }
}

.prize-progress {
  width: 130px;
  height: 130px;
  margin-top: 20px;
  @media screen and (max-width: 743px) {
    margin-top: 30px;
    width: 100px;
    height: 100px;
  }
  .circle-progress {
    &__progress {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      img {
        @media screen and (max-width: 743px) {
          width: 36px;
          height: 36px;
        }
      }
    }

    &__circle {
      transform: rotate(270deg);
      transform-origin: 50%;
    }
  }
}
</style>
